import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setLoading } from '../features/providers/generic';
import axios from '../utilities/axios';
import { useDispatch, useSelector } from 'react-redux';
import { Bars } from 'react-loader-spinner';
import { useState } from 'react';
import Form from './Form';
import {
  clearFormSubmitInvalidSlug,
  setFormSubmitInvalidSlug,
} from '../features/providers/orgInformationSlice';
import {
  getFirstMissingRequiredSlug,
  scrollToOrgField,
} from '../utilities/orgFormValidation';

const Signup = ({ preCheckout }) => {
  const [redirecting, setRedirecting] = useState(false);

  const initialLoading = useSelector(
    (state) => state.orgInformation.isLoading,
  );

  const Fields = useSelector((state) => state.orgInformation.data.fields);

  const loaderStyle = {
    minHeight: '30vh',
    height: '100%',
    width: '100%',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  };

  const dispatch = useDispatch();

  const fieldsExist = Object.keys(Fields).length > 0;
  const inputContext = useSelector((state) => state.generic.inputContext);

  const submit = async (e) => {
    e.preventDefault();
    const firstMissing = getFirstMissingRequiredSlug(Fields, inputContext);
    if (firstMissing) {
      dispatch(setFormSubmitInvalidSlug(firstMissing));
      scrollToOrgField(firstMissing);
      return;
    }
    dispatch(clearFormSubmitInvalidSlug());
    dispatch(setLoading(true));

    let validationPassed = false;
    try {
      const validateRes = await axios.post('/organization/validate', {
        fields: Fields,
      });

      validationPassed = true; // If we reach here, no 422
    } catch (err) {
      dispatch(setLoading(false));
      if (err.response?.status === 422) {
        let errors = err.response?.data?.data?.errors || []
        let errorMessages = errors.map((error) => {
          return `${error.message}\n`;
        })
        toast('Error! ' + errorMessages);
        return; // Stop submission
      } else {
        toast(`Validation error: ${err.message}`);
        return;
      }
    }

    // ✅ Proceed only if validation passed
    if (!validationPassed) {
      dispatch(setLoading(false));
      return;
    }

    try {

      if (preCheckout) {
        // set to local storage
        localStorage.setItem('preCheckout', JSON.stringify(Fields));
        // redirect to /add-organization
        window.location.href = '/checkout';

        return;
      }

      const request = await axios.post('/organization', {
        fields: Fields,
      });

      setRedirecting(true);

      // redirect to request.data.data.redirect
      const redirect = request?.data?.data?.redirect;
      if (redirect) {
        toast('Successfully updated, redirecting');
        window.location.href = request.data.data.redirect;
        return;
      }
      toast('Successfully updated');
    } catch (e) {
      toast('Error! ' + e.message);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const formElementsWrapStyle = {
    zIndex: 1,
    transition: 'opacity 0.3s ease-in-out',
    position: 'relative',
  };
  if (!fieldsExist || initialLoading || redirecting) {
    return (
      <div style={loaderStyle}>
        <Bars
          height="80"
          width="80"
          radius="9"
          color="#011C50"
          ariaLabel="three-dots-loading"
          wrapperStyle
          wrapperClass
        />
      </div>
    );
  }
  return (
    <>
      <form
        className="container mx-auto mt-5 flex justify-center"
        noValidate
        onSubmit={submit}
      >
        <div style={formElementsWrapStyle}>
          <Form fields={Fields} fieldsExist={fieldsExist} />
        </div>
      </form>
    </>
  );
};

export default Signup;
